import { defineStore } from 'pinia';

export const useScheduleServiceStore = defineStore('ScheduleServiceStore', {
  state() {
    return {
      enableScheduleServiceButton: false,
      scheduleServiceXTimeIframePopUpDetails: null,
    };
  },
  actions: {
    //Set the x-time iframe popup data upon clicking Schedule Service.
    setScheduleServiceXTimeIframePopUpDetails(payload) {
      this.scheduleServiceXTimeIframePopUpDetails = payload;
    },
  },
});
